import { Redirect } from 'react-router-dom';

/*
 * The old Saved, Requirements and Category pages were replaced by My Programs and Discover.
 * Old links and bookmarks land on the new pages instead of the old-style screens.
 */
export const SavedRedirect = () => <Redirect to="/summer-programs/manager" />;
export const RequirementsRedirect = () => <Redirect to="/summer-programs/manager" />;
export const CategoryRedirect = () => <Redirect to="/summer-programs" />;
